__turbopack_context__.v({
  "amount": "CampaignTools-module__JMVUkG__amount",
  "button": "CampaignTools-module__JMVUkG__button",
  "field": "CampaignTools-module__JMVUkG__field",
  "fields": "CampaignTools-module__JMVUkG__fields",
  "form": "CampaignTools-module__JMVUkG__form",
  "hint": "CampaignTools-module__JMVUkG__hint",
  "output": "CampaignTools-module__JMVUkG__output",
  "result": "CampaignTools-module__JMVUkG__result",
  "worksheet": "CampaignTools-module__JMVUkG__worksheet",
});
